package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Position.RELATIVE
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.TextAlign.LEFT
import com.downdogapp.client.AbstractView
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.controllers.start.MenuPage
import com.downdogapp.client.controllers.start.StartViewController
import com.downdogapp.client.resources.Image
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.start.SideBarMenuView.SideBarButton.Companion.sideBarButton
import com.downdogapp.client.widget.imageView
import com.downdogapp.client.widget.text
import org.w3c.dom.*

class SideBarMenuView : AbstractView() {

  private val sideBarButtons = mutableListOf<SideBarButton>()
  private val logoutButton: SideBarButton?

  override var root: HTMLDivElement = createDiv {
    width = SIDEBAR_WIDTH
    height = vh(100)

    div {
      height = vh(100)
      width = SIDEBAR_WIDTH
      position = RELATIVE
      bgColor = Color.black(0.8)

      verticalFlexBox {
        position = ABSOLUTE
        top = px(0)
        left = px(0)
        paddingLeft = MENU_PADDING_LEFT
        width = SIDEBAR_WIDTH

        horizontalFlexBox(verticalAlign = CENTER) {
          marginTop = px(28)

          imageView(Images.SIDE_MENU_TORTILLA_ICON) {
            paddingLeft = px(5)
          }

          label(text = "Down Dog", fontSize = 22, fontWeight = FontWeight.MEDIUM) {
            paddingLeft = px(10)
          }
        }

        div {
          marginTop = px(32)

          for ((index, page) in StartViewController.allPages.withIndex()) {
            div {
              sideBarButtons.add(
                sideBarButton(
                  active = index == StartViewController.currentPageIndex,
                  icon = StartViewController.getTabBarIcon(page),
                  lazyText = { page.title },
                  clickFn = { StartViewController.goToPage(page) }
                )
              )
            }
          }
        }
      }

      div {
        position = ABSOLUTE
        bottom = px(0)
        left = px(0)
        paddingLeft = MENU_PADDING_LEFT
        marginBottom = px(10)
        width = SIDEBAR_WIDTH

        logoutButton = if (MANIFEST.displayLogoutMenuButton)
          sideBarButton(
            active = true,
            icon = Images.LOGOUT_ICON,
            lazyText = { Strings.LOGOUT },
            clickFn = MenuPage::logoutClicked
          )
        else
          null
      }
    }
  }

  init {
    refreshView()
  }

  fun refreshView() {
    sideBarButtons.forEachIndexed { index, view ->
      if (StartViewController.isPageVisible(index)) {
        view.show()
      } else {
        view.hide()
      }
      view.setActive(index == StartViewController.currentPageIndex)
      view.refresh()
    }
    logoutButton?.refresh()
  }

  private class SideBarButton(active: Boolean,
                              val icon: Image,
                              val lazyText: () -> String, // Needed to update the text when the language changes
                              clickFn: () -> Unit) : AbstractView() {

    private var image: HTMLImageElement
    private var label: HTMLSpanElement

    override val root = createDiv {
      width = BUTTON_WIDTH

      horizontalFlexBox(verticalAlign = CENTER) {
        image = imageView(image = icon)
        label = label(text = lazyText(), fontSize = 18, textAlign = LEFT)
        onClick {
          App.unwindToViewController(StartViewController::class)
          clickFn()
        }
      }
    }

    init {
      setActive(active)
    }

    fun setActive(value: Boolean) {
      root.opacity = if (value) 1.0 else 0.4
    }

    fun refresh() {
      label.text = lazyText()
    }

    companion object {

      fun HTMLElement.sideBarButton(active: Boolean,
                                    icon: Image,
                                    lazyText: () -> String,
                                    clickFn: () -> Unit,
                                    init: HTMLDivElement.() -> Unit = {}): SideBarButton {
        val view = SideBarButton(active = active, icon = icon, lazyText = lazyText, clickFn = clickFn)
        append(view.root)
        view.root.init()
        return view
      }
    }
  }

  companion object {

    val MENU_PADDING_LEFT = px(10)
    val BUTTON_WIDTH = px(180)
    val SIDEBAR_WIDTH = px(240)

    fun HTMLElement.sidebarMenuView(): SideBarMenuView {
      val view = SideBarMenuView()
      append(view.root)
      return view
    }
  }
}
